import React from 'react';
import { Button, FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { faRedoAlt } from '@fortawesome/pro-regular-svg-icons';
import '../GeneratedCreatives.scss';

type ConversationFailProps = {
  onReload: VoidFunction;
};
const ConversationFail = ({ onReload }: ConversationFailProps) => {
  return (
    <FlexBox
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      UNSAFE_className="fail-wrapper"
      gap="16px"
    >
      <div className="fail-icon">
        <FontAwesomeIcon icon={faExclamationTriangle} color="#FF2D38" />
      </div>
      <FlexBox flexDirection="column" gap="8px">
        <h3 className="heading">Oops! Conversation Failed to Load</h3>
        <p className="desc">
          We're having trouble bringing up your conversation. Give it another shot.
        </p>
      </FlexBox>
      <Button
        kind="link"
        iconLeft={<FontAwesomeIcon icon={faRedoAlt} />}
        onClick={onReload}
        weight="bold"
      >
        Reload Chat
      </Button>
    </FlexBox>
  );
};

export default ConversationFail;
